import { NavbarV2 } from "@/components/landing-v2/NavbarV2";
import { Footer } from "@/components/landing/Footer";
import { FeaturesHero } from "@/components/features/FeaturesHero";
import { FeaturesBento } from "@/components/features/FeaturesBento";

export function FeaturesPage() {
  return (
    <div className="bg-background min-h-screen">
      <NavbarV2 />
      <main>
        <FeaturesHero />
        <FeaturesBento />
      </main>
      <Footer />
    </div>
  );
}
